import type { AxiosRequestConfig } from 'axios'
import axios from 'axios'
import { message } from 'antd'

// eslint-disable-next-line n/prefer-global/process
const baseURL = process.env.NODE_ENV === 'development' ? '' : ''

const timeout = 30000

const service = axios.create({
  timeout,
  baseURL,
  withCredentials: true,
})

service.interceptors.request.use(
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  (config: AxiosRequestConfig) => {
    config.headers = {

    }
    return config
  },
  (error) => {
    Promise.reject(error)
  },
)

interface axiosTypes<T> {
  data: T
  status: number
  statusText: string
}

interface responseTypes<T> {
  returnCode: any
  code: number
  msg: string
  result: T
}

function requestHandler<T>(method: 'get' | 'post' | 'put' | 'delete', url: string, params: object = {}, config: AxiosRequestConfig = {}): Promise<T> {
  let response: Promise<axiosTypes<responseTypes<T>>>
  switch (method) {
    case 'get':
      response = service.get(url, { params: { ...params }, ...config })
      break
    case 'post':
      response = service.post(url, { ...params }, { ...config })
      break
    case 'put':
      response = service.put(url, { ...params }, { ...config })
      break
    case 'delete':
      response = service.delete(url, { params: { ...params }, ...config })
      break
  }

  return new Promise<T>((resolve, reject) => {
    response.then((res) => {
      const data = res.data
      if (data.code === 200 || data.returnCode === '200') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        resolve(data)
      }
      else {
        resolve(data as any)
        // const e = JSON.stringify(data)
        // message.info(`api error：${e}`)
        // reject(data)
      }
    }).catch((error) => {
      let info = ''
      switch (error.response?.status) {
        case 400:
          info = 'An error occurred in the request. The server did not create or modify data. '
          break
        case 401:
          info = 'User has no permissions (wrong token, username, password).'
          break
        case 403:
          info = 'The user is authorized, but access is forbidden. '
          break
        case 404:
          info = 'The request was made for a nonexistent record, no action was taken by the server.'
          break
        case 406:
          info = 'Requested format not available. '
          break
        case 410:
          info = 'The requested resource is permanently deleted and will not be retrieved.'
          break
        case 422:
          info = 'A validation error occurred while creating an object. '
          break
        case 500:
          info = 'Server error, please check server. '
          break
        case 502:
          info = 'Gateway error.'
          break
        case 503:
          info = 'Service unavailable, server temporarily overloaded or maintained.'
          break
        case 504:
          info = 'Gateway timed out.'
          break
      }
      const e = JSON.stringify(error)
      message.info(info)
      reject(error)
    })
  })
}

const request = {
  get: <T>(url: string, params?: object, config?: AxiosRequestConfig) => requestHandler<T>('get', url, params, config),
  post: <T>(url: string, params?: object, config?: AxiosRequestConfig) => requestHandler<T>('post', url, params, config),
  put: <T>(url: string, params?: object, config?: AxiosRequestConfig) => requestHandler<T>('put', url, params, config),
  delete: <T>(url: string, params?: object, config?: AxiosRequestConfig) => requestHandler<T>('delete', url, params, config),
}

export { request }
